export default __webpack_public_path__ + "static/media/icon-fourth-masonry.eed9670a.svg";